import { ethers } from "ethers";
import { useEffect } from "react";
import Loader from "react-spinners/GridLoader";
import styled from "styled-components";
import { Dashboard } from "styled-icons/material";

import ProvenanceRecordTable from "../../components/ProvenanceRecordTable";
import { useGnarlyGoatsContracts } from "../../hooks/useGnarlyGoatsContracts";
import { Metadata, useProvenance } from "../../hooks/useProvenance";
import {
  DashboardWrapper,
  Interface,
  PageWrapper,
  Text,
  Title
} from "../../theme";

const StyledTable = styled.table`
	font-size: 12pt;
`

const ConcatenatedImageHashes = styled.div`
	display: inline-block;
	word-break: break-all;
	overflow-wrap: anywhere;
	text-align: justify;
	overflow-y: scroll;
	overflow-x: hidden;
	max-height: 150px;
	box-sizing: border-box;
	inline-size: 85%;
`

const AboutPage = (props: any) => {
	return (
		<PageWrapper>
			<DashboardWrapper noTheme>
				<Title>Welcome to the Club</Title>
				<Text color1>
					Gnarly Goats Island Club is a collection of 5,366 unique digital
					artwork collectibles represented as NFTs on the Ethereum network. Your
					Gnarly Goat doubles as your Island Club membership card and grants
					access to members-only benefits.
				</Text>
			</DashboardWrapper>
			<DashboardWrapper>
				<Title primary1>{`Terms & Conditions`}</Title>
				<Text color1>
					This website is merely an interface enabling users to purchase and
					exchange digital collectibles on the Ethereum network. Individual
					participants are solely responsible for the safety and management of
					their own private Ethereum wallets and validating all transactions and
					contracts generated by this website before approval. Furthermore, as
					the Gnarly Goats Island Club smart contract runs on the Ethereum
					network, it is impossible to undo, reverse, or restore any
					transactions. This website and its related services are provided “as
					is” and “as available” without warranty of any kind. By using this
					website you accept sole responsibility for any and all transactions
					involving Gnarly Goats Island Club digital collectibles.
				</Text>
				<Title primary1>{`Ownership`}</Title>
				<Text left color1>
					<Text left primary3>
						i.&emsp;Only You Own Your NFT
					</Text>
					<br />
					<br />
					Each Gnarly Goat is represented as an NFT on the Ethereum blockchain.
					When you purchase a Gnarly Goat NFT, you own the underlying Gnarly
					Goat, the artwork, entirely. Ownership of the NFT is mediated entirely
					by the Smart Contract and the Ethereum Network: at no point may we
					seize, freeze, or otherwise modify the ownership of any Gnarly Goat.
				</Text>
				<Text left color1>
					<Text left primary3>
						ii.&emsp;Personal Use
					</Text>
					<br />
					<br />
					Subject to your continued compliance with these Terms, Gnarly Labs LLC
					grants you a worldwide, royalty-free license to use, copy, and display
					the purchased Art, along with any extensions that you choose to create
					or use, solely for the following purposes: (i) for your own personal,
					non-commercial use; (ii) as part of a marketplace that permits the
					purchase and sale of your Gnarly Goat / NFT, provided that the
					marketplace cryptographically verifies each Gnarly Goat owner’s rights
					to display the Art for their Gnarly Goat to ensure that only the
					actual owner can display the Art; or (iii) as part of a third party
					website or application that permits the inclusion, involvement, or
					participation of your Gnarly Goat, provided that the
					website/application cryptographically verifies each Gnarly Goat
					owner’s rights to display the Art for their Gnarly Goat to ensure that
					only the actual owner can display the Art, and provided that the Art
					is no longer visible once the owner of the Gnarly Goat leaves the
					website/application.
				</Text>
				<Text left color1>
					<Text left primary3>
						iii.&emsp;Commercial Use
					</Text>
					<br />
					<br />
					Subject to your continued compliance with these Terms, Gnarly Labs LLC
					grants you an unlimited, worldwide license to use, copy, and display
					the purchased Art for the purpose of creating derivative works based
					upon the Art (“Commercial Use”). Examples of such Commercial Use would
					e.g. be the use of the Art to produce and sell merchandise products
					(T-Shirts etc.) displaying copies of the Art. For the sake of clarity,
					nothing in this Section will be deemed to restrict you from (i) owning
					or operating a marketplace that permits the use and sale of Gnarly
					Goats generally, provided that the marketplace cryptographically
					verifies each Gnarly Goat owner’s rights to display the Art for their
					Gnarly Goat to ensure that only the actual owner can display the Art;
					(ii) owning or operating a third party website or application that
					permits the inclusion, involvement, or participation of Gnarly Goats
					generally, provided that the third party website or application
					cryptographically verifies each Gnarly Goat owner’s rights to display
					the Art for their Gnarly Goat to ensure that only the actual owner can
					display the Art, and provided that the Art is no longer visible once
					the owner of the Purchased Gnarly Goat leaves the website/application;
					or (iii) earning revenue from any of the foregoing.
				</Text>
			</DashboardWrapper>
		</PageWrapper>
	)
}
export default AboutPage
